export default "__VITE_ASSET__uDS1YrxE__"